import { MinimalToken } from '@bifrost-platform/bifront-sdk-react-biholder';
import { useMemo } from 'react';
import styled from 'styled-components';
import TokenIcon from './TokenIcon';

export interface Props {
  tokens?: MinimalToken[];
  isHideChain?: boolean;
  size?: number;
}

const TokenWrapper = styled.div<{
  length: number;
  index: number;
  gap: number;
}>`
  ${({ length, index, gap }) =>
    `
      margin-left: ${-gap}px;
      transform: translateX(-${(length - index - 1) * -gap}px);
    `}
`;
const TokenPairImageContainer = styled.div<{
  gap: number;
}>`
  position: relative;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  ${({ gap }) => (gap ? `padding-left: ${gap}px;` : '')}
`;

export default function TokenPairIcon({
  tokens,
  isHideChain = true,
  size = 24,
}: Props) {
  const gap = useMemo(() => size / 6, [size]);
  const reversedToken = useMemo(() => [...(tokens ?? [])]?.reverse(), [tokens]);

  return (
    <TokenPairImageContainer gap={gap}>
      {reversedToken?.map((token, tokenIndex) => (
        <TokenWrapper
          key={token.chainId + token.address}
          length={reversedToken.length}
          index={tokenIndex}
          gap={gap}
        >
          <TokenIcon {...token} isHideChain={isHideChain} size={size} />
        </TokenWrapper>
      ))}
    </TokenPairImageContainer>
  );
}
